import { MyFleetEndpointFactory } from '../app/components/myfleet/myfleet.endpoint.factory';
import { ShellEndpointFactory } from '../app/components/shell/shell.endpoints.factory';
import { DashboardEndpointFactory, ServiceManagementEndpointFactory } from './interfaces';
import { AuthEndpointFactory } from './interfaces/endpoints/auth/auth.endpoint.factory';
import { RolesEndpointFactory } from './interfaces/endpoints/roles-permissions';
import { EnvironmentRef } from './interfaces/environment.interface';

const apiBaseUrl: string ='https://dev-api.toyotaforklift.com/portal/api/';
const aemBaseUrl: string = 'https://publish-p70005-e618018.adobeaemcloud.com';
const requestServiceUrl: string =
  'https://qa.toyotaforklift.com/parts-and-service/request-a-service-quote';
const buyPartsUrl: string =
  'https://shop-qa.toyotaforklift.com/en/parts-group?autoLogin=1';
const manageFinancingUrl: string = 'https://www.toyotacf.com';
const openContactFormUrl: string = 'https://qa.toyotaforklift.com/contact-a-dealer';
const requestServiceEquipmentDetails: string = 'https://qa.toyotaforklift.com/parts-and-service/request-a-service-quote';
const warrantyPromoBannerUrl: string = 'https://qa.toyotaforklift.com/us/en/parts-and-service/360-support';
const buyPartsPromoBannerUrl: string = 'https://shop-qa.toyotaforklift.com/en/?autoLogin=1';
const azureKey: string = 'ACkF9_n4ZlxeLom-n0lOjQ6qACs74-evw9MXO1BhKLs';
const appWalkmeUrl = 'https://cdn.walkme.com/users/5624a3dccd1a4cdeaeaba0672fb40626/test/walkme_5624a3dccd1a4cdeaeaba0672fb40626_https.js';
const shopDeliveryAddressUrl: string = 'https://shop-qa.toyotaforklift.com/en/account-dashboard/delivery-addresses';
const zendeskChatbotUrl: string = 'https://static.zdassets.com/ekr/snippet.js?key=3926633e-2b49-4b39-ae2d-b8d3812fb57e';
const myInsightsPortalUrl: string = 'https://toyotaqa.npgtssweb.com/';
const ecomBaseUrl: string = 'https://shop-qa.toyotaforklift.com';

export const environment: EnvironmentRef = {
	production: false,
	env: 'dev',
	baseUrl: apiBaseUrl,
	endpoints: {
		auth: AuthEndpointFactory.build(`${apiBaseUrl}`),
		roles: RolesEndpointFactory.build(`${apiBaseUrl}`),
		header: ShellEndpointFactory.build(`${apiBaseUrl}`),
		myfleetlabels: MyFleetEndpointFactory.build(`${apiBaseUrl}`),
		serviceManagement: ServiceManagementEndpointFactory.build(`${apiBaseUrl}`),
		dashboard: DashboardEndpointFactory.build(`${apiBaseUrl}`)
	},
	b2cPolicies: {
		names: {
			signUpSignIn: 'B2C_1A_DXS_SSO_DEV_SIGNUPSIGNIN',
			editProfile: ''
		},
		authorities: {
			signUpSignIn: {
				authority:
          'https://login.tmhrnd.com/login.tmhrnd.com/B2C_1A_DXS_SSO_DEV_SIGNUPSIGNIN'
			},
			editProfile: {
				authority: ''
			}
		},
		authorityDomain: 'login.tmhrnd.com'
	},
	clientId: '7de8e17c-5379-4a52-b339-140908aac26c',
	scope: {
		read: 'https://login.tmhrnd.com/portal-api/portal.read'
	},
	aemBaseUrl: aemBaseUrl,
	appWalkmeUrl: appWalkmeUrl,
	zendeskChatbotUrl: zendeskChatbotUrl,
	azureMapsApiKey: azureKey,
	requestServiceUrl: requestServiceUrl,
	buyPartsUrl: buyPartsUrl,
	manageFinancingUrl: manageFinancingUrl,
	openContactFormUrl: openContactFormUrl,
	requestServiceEquipmentDetails: requestServiceEquipmentDetails,
	warrantyPromoBannerUrl: warrantyPromoBannerUrl,
	buyPartsPromoBannerUrl: buyPartsPromoBannerUrl,
	shopDeliveryAddressUrl: shopDeliveryAddressUrl,
	myInsightsPortalUrl: myInsightsPortalUrl,
	analytics: {
		scripts: {
			launch: {
				src: 'https://assets.adobedtm.com/81c40e86aed0/bef7f0d1cfa1/launch-43f538417445-development.min.js'
			}
		}
	},
	ecomBaseUrl: ecomBaseUrl
};
